import {localeFromDomain} from "frontend-resources/js/Helpers/Locales";

export default class Money {
  private readonly _amount: number;
  private readonly _currency: string;
  constructor({amount, currency}) {
    this._amount = Number(String(amount).replace(',',''));
    this._currency = currency;
  }
  get amount(): number {
    return this._amount;
  }

  get currency(): string {
    return this._currency;
  }

  isPositive(): boolean {
    return this._amount > 0;
  }

  isPositiveOrEqualToZero(): boolean {
    return this._amount >= 0;
  }

  isNegative(): boolean {
    return this._amount < 0;
  }

  multiply(factor: number): Money {
    return new Money({amount: this._amount * factor, currency: this.currency});
  }

  equals(money: Money): boolean {
    return money.amount === this.amount && money.currency === this.currency;
  }

  round(decimals: number): Money {
    return new Money({amount: +this._amount.toFixed(decimals), currency: this.currency});
  }

  subtract(money: Money): Money {
    return new Money({ amount: this._amount - money.amount, currency: this.currency });
  }

  add(money: Money): Money {
    return new Money({ amount: this._amount + money.amount, currency: this.currency });
  }

  format() : string {
    return new Intl.NumberFormat(localeFromDomain().replace('_', '-'), {
      style: 'currency',
      currency: this._currency,
    }).format(this._amount);
  }

  static combine(...moneys: Money[]) {
      let amount = 0;

      let currency = moneys[0] ? moneys[0].currency : 'EUR';

      moneys.forEach(money => {
          amount += money.amount;
          if (money.currency !== currency) {
            console.error('You cannot combine money objects with different currencies!');
          }
      });

      return new Money({ amount, currency })
  }
}
